/**
 * Custom Referral Banner
 * Displays a referral banner when users visit with referral parameters
 */

class CustomReferralBanner {
  constructor() {
    this.defaultStoreName = window.Theme?.translations?.referral_banner_default_store_name || 'your local skincare centre';
    this.init();
  }

  init() {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => this.handleReferralBanner());
    } else {
      this.handleReferralBanner();
    }
  }

  handleReferralBanner() {
    const params = new URL(document.location.toString()).searchParams;
    const name = params.get('rfsn');

    if (sessionStorage.getItem('referral_name') !== null) {
      this.showReferralBanner(sessionStorage.getItem('referral_name'));
      return;
    }

    if (name !== null && sessionStorage.getItem('referral_name') === null) {
      this.fetchReferralData(name);
    }
  }

  async fetchReferralData(name) {
    
    const resolvedTheme = (typeof window !== 'undefined' && window.Theme)
      ? window.Theme
      : (typeof Theme !== 'undefined' ? Theme : undefined);
    const config = resolvedTheme?.referralBanner;
    
    if (!config || !config.spreadsheetId || !config.apiKey) {
      console.warn('Referral banner API configuration missing, using default store name');
      sessionStorage.setItem('referral_name', this.defaultStoreName);
      this.showReferralBanner(this.defaultStoreName);
      return;
    }

    const url = `https://sheets.googleapis.com/v4/spreadsheets/${config.spreadsheetId}/values/${config.tabName}?alt=json&key=${config.apiKey}`;
    
    try {
      const response = await fetch(url);
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      const data = await response.json();
      
      let showDefault = true;
      
      if (data && data.values && Array.isArray(data.values)) {
        for (let i = 0; i < data.values.length; i++) {
          if (data.values[i] && data.values[i][0] === name) {
            showDefault = false;
            sessionStorage.setItem('referral_name', data.values[i][1]);
            this.showReferralBanner(data.values[i][1]);
            break;
          }
        }
      }

      if (showDefault) {
        sessionStorage.setItem('referral_name', this.defaultStoreName);
        this.showReferralBanner(this.defaultStoreName);
      }
    } catch (error) {
      console.error('Error fetching referral data:', error);
      sessionStorage.setItem('referral_name', this.defaultStoreName);
      this.showReferralBanner(this.defaultStoreName);
    }
  }

  showReferralBanner(storeName) {
    if (storeName === undefined || storeName === '') {
      storeName = this.defaultStoreName;
    }

    const nameElement = document.getElementById('store_referral_name');
    const bannerElement = document.querySelector('.store_referral');
    
    if (nameElement && bannerElement) {
      nameElement.innerText = storeName;
      document.body.style.marginTop = '75px';
      bannerElement.style.display = 'flex';
    }
  }
}

new CustomReferralBanner();
